module.exports = __webpack_public_path__ + "static/silo-ai-065c2caca2238af61e6080cb11972581.svg";